import { TRENDING_TYPE_CHANGE } from './actionTypes';

export default (objectType, trendingType) => ({
  type: TRENDING_TYPE_CHANGE,
  payload: {
    objectType,
    trendingType,
  }
});